var generateComponentTheme = function generateComponentTheme(_ref) {
  var breakpoints = _ref.breakpoints,
    spacing = _ref.spacing;
  return {
    alertsPadding: spacing.medium,
    alertsTopPadding: spacing.large,
    alertsMobilePadding: spacing.small,
    alertsZIndex: '7777',
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium)
  };
};
export default generateComponentTheme;